<a href={{URL_CodeOnline}} target="_blank" class="card">
    <img src="/assets/images/codeonline-logo-white.svg" alt="CodeOnline" />
    <span [translate]="'CodeOnline.def'"></span>
    <mat-icon class="mat-12">open_in_new</mat-icon>
</a>